<template>
  <v-sheet style="position: relative;">
    <v-card flat>
      <v-card-title flex>
        <v-file-input
          show-size
          label="Chọn File"
          @change="onFileSelected"
          :value="value"
          :disabled="isLoading"
        ></v-file-input>
        <v-text-field
          v-model="search"
          clear-icon="mdi-close"
          clearable
          append-icon="mdi-magnify"
          label="Tìm Kiếm"
          class="mx-12"
        ></v-text-field>
        <v-btn
          depressed
          small
          color="green"
          @click="upload"
          :disabled="isLoading || loading"
          >Lưu lại</v-btn
        >
      </v-card-title>
      <v-data-table
        class="mb-2 flex-center-between"
        style="flex-direction: row-reverse;"
        :headers="headers"
        :items="students"
        :search="search"
      >
        <template v-slot:item.major="{ item }">
          <router-link v-if="item.major" :to="'/major/' + item.major.id">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ item.major.code }}</span>
              </template>
              <span>{{ item.major.title }}</span>
            </v-tooltip>
          </router-link>
        </template>
        <template v-slot:item.generation="{ item }">
          <router-link
            v-if="item.generation"
            :to="'/generation/' + item.generation.id"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ item.generation.code }}</span>
              </template>
              <span>{{ item.generation.name }}</span>
            </v-tooltip>
          </router-link>
        </template>
        <template v-slot:item.uploadStatus="{ item }">
          <v-chip small dark :color="getColor(item.uploadStatus)">{{
            item.uploadStatus | getStatus
          }}</v-chip>
        </template>
        <template v-slot:item.dob="{ item }">{{
          item.dob | familiarizeDate
        }}</template>
      </v-data-table>
    </v-card>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import XLSX from 'xlsx'
import moment from 'moment'
export default {
  components: {},
  data() {
    return {
      search: '',
      dialog: false,
      selectedStudent: {},
      migratedStudents: [],
      value: null,
      isLoading: true,
      headers: [
        {
          text: 'Upload Status',
          value: 'uploadStatus',
          align: 'left',
          sortable: false
        },
        { text: 'Tên Học Sinh', value: 'name' },
        { text: 'Code', value: 'username' },
        { text: 'Email', value: 'email' },
        { text: 'phone', value: 'phone' },
        { text: 'Giới Tính', value: 'gender' },
        { text: 'Địa Chỉ', value: 'address' },
        { text: 'Facebook', value: 'facebook' },
        { text: 'Năm Sinh', value: 'dob' },
        { text: 'Mật Khẩu', value: 'password' },
        { text: 'Chuyên Ngành', value: 'major' },
        { text: 'Khóa', value: 'generation' }
      ]
    }
  },
  computed: {
    ...mapGetters('app', ['department']),
    ...mapGetters('studentImporter', [
      'students',
      'loading',
      'majors',
      'generations'
    ]),
    ...mapGetters('app', ['roleIdByName', 'roles']),
    isProcessing() {
      return this.loading || this.isLoading
    }
  },
  async created() {
    this.isLoading = true
    await this.fetchMajors({ department: this.department.id })
    await this.fetchGenerations({ department: this.department.id })
    this.isLoading = false
  },
  methods: {
    ...mapActions('studentImporter', [
      'fetchGenerations',
      'fetchMajors',
      'setStudents',
      'setStudent',
      'migrateStudents',
      'validateStudents'
    ]),
    ...mapActions('user', ['generateUserName', 'validateEmail']),
    onFileSelected(file) {
      let self = this
      let reader = new FileReader()
      reader.onload = function(e) {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array' })
        let sheetName = workbook.SheetNames[0]
        let worksheet = workbook.Sheets[sheetName]
        let students = XLSX.utils.sheet_to_json(worksheet)

        self.setStudents(
          students.map((student, index) => {
            return {
              ...self.$utils.filterObject(student),
              dob: moment(student.dob, 'DD/MM/YYYY')
                .endOf('date')
                .toISOString(),
              key: index,
              phone: student.phone,
              department: self.department.id,
              major: self.majors[student.major],
              generation: self.generations[student.generation],
              uploadStatus: 'validate',
              address: student.frequentlyAddress,
              status: 'active',
              tags: student.tags,
              password: '123123',
              role: self.roleIdByName('Student'),
              data: {
                frequentlyAddress: student.frequentlyAddress,
                currentLive: student.currentLive,
                birthPlace: this.birthPlace,
                achievements: this.achievements,
                facebook: student.facebook,
                address: student.address,
                university: student.university,
                company: student.company,
                highSchool: student.highSchool,
                dadName: student.dadName,
                dadEmail: student.dadEmail,
                dadPhone: student.dadPhone,
                momName: student.momName,
                momPhone: student.momPhone,
                momEmail: student.momEmail
              }
            }
          })
        )
        self.validateStudents()
      }
      reader.readAsArrayBuffer(file)
    },
    getColor(status) {
      if (status === 'ready') return 'green'
      else if (status === 'success') return 'blue'
      else if (status === 'failed') return 'red'
      else if (status === 'loading') return 'gray'
      else if (status === 'duplicated') return 'orange'
      else if (status === 'validate') return 'gray'
    },

    upload() {
      this.migrateStudents()
    }
  },
  filters: {
    getStatus(status) {
      if (status === 'ready') return 'Hợp Lệ'
      else if (status === 'success') return 'Đã Lưu'
      else if (status === 'failed') return 'Không Hợp Lệ'
      else if (status === 'loading') return 'Đang Lưu'
      else if (status === 'duplicated') return 'Bị Trùng'
      else if (status === 'validate') return 'Đang Kiểm Tra'
    },
    familiarizeDate: time => {
      if (!time) {
        return 'None'
      }
      return moment(time).format('DD/MM/MM')
    },
    currencyTuition: tuition => {
      if (!tuition) {
        return '0 đ'
      }
      return new Intl.NumberFormat('vn-VN', {
        style: 'currency',
        currency: 'VND'
      }).format(tuition)
    },
    SimplizedDate: time => {
      if (!time) {
        return 'không có'
      }
      return moment(time).format('DD/MM')
    }
  }
}
</script>

To change the font size for a single component, such as a text field,
application-wide:

<style>
.v-select__level-sale {
  font-size: 1em;
  border: none;
}
</style>
